import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export const CTAButton: React.FC<ButtonProps> = ({
  children,
  onClick,
  href,
  className = ''
}) => {
  const sharedProps = {
    whileHover: {
      scale: 1.02
    },
    whileTap: {
      scale: 0.98
    },
    animate: {
      boxShadow: ['0px 0px 0px rgba(45, 80, 22, 0)', '0px 0px 20px rgba(45, 80, 22, 0.4)', '0px 0px 0px rgba(45, 80, 22, 0)']
    },
    transition: {
      boxShadow: {
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut' as const
      }
    },
    className: `relative overflow-hidden bg-brand-green text-white font-bold py-4 px-8 rounded-full hover:bg-brand-greenLight transition-colors duration-300 w-full md:w-auto text-sm md:text-base tracking-wide uppercase inline-block text-center no-underline ${className}`
  };
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" {...sharedProps} data-id="element-38">
        <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-39">
          {children}
        </span>
      </motion.a>;
  }
  return <motion.button onClick={onClick} {...sharedProps} data-id="element-40">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-41">
        {children}
      </span>
    </motion.button>;
};